import OrderAction from './orderAction';
import Attendee from '../../../models/attendeeModel';
import Order from '../models/orderModel';
import DeleteActionAttendee from '../../../pages/attendee/actions/deleteAction';

export default class DeleteAction extends OrderAction {
    static NAME = 'delete';
    static ASYNCHRONOUS_LIMIT_MIN = 25;

    //only reserved and payed
    static condition(order) {
        return ['valid', 'reservation'].includes(order.status) && order.attendee_count > order.attendees_deleted_count && super.payment_plan_condition(order);
    }

    static is_attendee_valid({ attendee, order }) {
        return DeleteActionAttendee.is_attendee_valid({ attendee, order });
    }

    run({ orders = null, attendees = null }) {
        if (attendees) {
            //only not deleted
            const to_delete = attendees.filter(a => !a.removed);
            return Attendee.perform_action(DeleteActionAttendee.NAME, to_delete, { organization: this.organization, event: this.event });
        }

        return Order.perform_action(this.constructor.NAME, orders || this.filtered_items, { organization: this.organization, event: this.event }, this.isAsync(orders));
    }

    onActionDone() {
        if (!this.async) {
            this.sync();
        }
        this.onClose();
    }
}
